import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { QRCodeSVG } from 'qrcode.react';
import FooterLogo from './FooterLogo';
import Logo from './Logo';
import { colors } from '../style/tokens';
import { headerBg } from '../style/header';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--sfondo, ${colors.bg});
  font-family: 'Outfit', sans-serif;
  overflow-y: auto;
`;

const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 26px;
  min-height: 82px;
  flex-shrink: 0;
  position: relative;
  background: ${headerBg};
`;

const LogoCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 20px;
  padding: 32px;
  text-align: center;
`;

const PhoneIcon = styled.div`
  width: 52px;
  height: 52px;
  border: 3px solid #333;
  border-radius: 10px;
  position: relative;
  margin-bottom: 8px;
  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #333;
    position: absolute;
    bottom: 7px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.text};
  margin: 0;
`;

const Message = styled.p`
  font-size: 14px;
  color: ${colors.muted};
  line-height: 1.6;
  max-width: 320px;
  margin: 0;
`;

const Hint = styled.p`
  font-size: 12px;
  color: #aaa;
  line-height: 1.6;
  max-width: 300px;
  margin: 0;
`;

const QRWrapper = styled.div`
  background: #fff;
  padding: 12px;
  border-radius: 12px;
  display: inline-flex;
`;

const MobileRequired: React.FC = () => {
  const intl = useIntl();
  const currentUrl = window.location.href;
  return (
    <Page>
      <TopBar>
        <span style={{ width: 42 }} />
        <LogoCenter><Logo /></LogoCenter>
        <span style={{ width: 42 }} />
      </TopBar>
      <Body>
        <PhoneIcon />
        <Title>{intl.formatMessage({ id: 'mobileRequired.title' })}</Title>
        <Message>{intl.formatMessage({ id: 'mobileRequired.message' })}</Message>
        <QRWrapper>
          <QRCodeSVG value={currentUrl} size={180} level="M" />
        </QRWrapper>
        <Hint>{intl.formatMessage({ id: 'mobileRequired.hint' })}</Hint>
      </Body>
      <FooterLogo />
    </Page>
  );
};

export default MobileRequired;
